import { render, staticRenderFns } from "./RewardBindPro.vue?vue&type=template&id=92faa148&scoped=true"
import script from "./RewardBindPro.vue?vue&type=script&lang=js"
export * from "./RewardBindPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92faa148",
  null
  
)

export default component.exports